<div class="clearfix">
  <customer-select class="fr sm:w-full mx:mr-8"></customer-select>
</div>
<div class="order-content flex-center">
    <img src="assets/new/process.svg" class="success sm:mt-[52px] mx:mt-[150px]" />
    <p class="title mb-[22px]">{{"ORDER_IN_PROGRESS" | translate}}</p>
    <p class="w-full mx:w-[769px] sm:w-full text-center mb-[22px]">{{"ORDER_BE_PLACED" | translate}}</p>
    <p class="w-full mx:w-[769px] sm:w-full text-center mb-[160px]">{{"CHECK_TIPS" | translate}}</p>
  </div>
